import { Button } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import ImportAllMaterials from './components/import-all-materials/import-all-materials'
import RecalcCalculationsFromExcel from './components/recalc-calculations-from-excel/recalc-calculations-from-excel'
import VerifyCalculations from './components/verify-calculations/verify-calculations'

const DevPageStyled = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 160px 24px 24px 24px;
    overflow-y: auto;
`

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 1400px;
    flex: 1 1 auto;
    min-height: 0;
`

interface DevPageProps {}

const DevPage: FC<DevPageProps> = () => {
    return (
        <DevPageStyled>
            <ButtonsContainer>
                <Button
                    onClick={() => {
                        throw new Error('text error to glitch')
                    }}
                >
                    text error to glitch
                </Button>

                <ImportAllMaterials />
                <RecalcCalculationsFromExcel />
                <VerifyCalculations />
            </ButtonsContainer>
        </DevPageStyled>
    )
}

export default DevPage
